import { apiGet, apiPost } from './client'

/**
 * Notele omului din bara de jos - `memo/*` din portal (`MemoController`).
 */
export interface MemoNoteRow {
  id: number
  title: string
  snippet: string
  updated: string | null
}

export interface MemoNote {
  id: number
  title: string
  body: string
  updated: string | null
}

export function memoCount(): Promise<{ notes: number }> {
  return apiGet('/memo/count')
}

export function memoNotes(): Promise<{ ready: boolean; notes: MemoNoteRow[] }> {
  return apiGet('/memo/notes')
}

export function memoNote(id: number): Promise<MemoNote> {
  return apiGet(`/memo/note/${id}`)
}

export function memoSaveNote(id: number, title: string, body: string): Promise<{ id: number; notes: number }> {
  return apiPost('/memo/saveNote', { id, title, body })
}

export function memoDeleteNote(id: number): Promise<{ notes: number }> {
  return apiPost('/memo/deleteNote', { id })
}
